import * as actionTypes from './actionTypes';

export const addDeposit=(deposit)=>{
    return {
        type:actionTypes.ADD_DEPOSIT,
        payload:deposit
    }
}